import React from 'react';
import { ArrowUpIcon, ArrowDownIcon } from '@heroicons/react/24/solid';

const KpiCard = ({ title, value, icon, change, changeType, modifierClass = 'default' }) => {
  const isPositive = changeType === 'positive';
  const changeClass = isPositive ? 'kpi-card__change--positive' : 'kpi-card__change--negative';
  const ChangeIcon = isPositive ? ArrowUpIcon : ArrowDownIcon;

  // Combine base class with modifier class for styling hooks
  const cardClasses = `kpi-card kpi-card--${modifierClass}`;

  return (
    <div className={cardClasses}>
        <div className="kpi-card__icon-wrapper">
            {/* Icon component passed in, size/color handled by CSS via modifier */}
            {icon}
        </div>
        <div className="kpi-card__content">
            <p className="kpi-card__title">{title}</p>
            <div className="kpi-card__value-row">
                <p className="kpi-card__value">{value}</p>
                {change && (
                     <p className={`kpi-card__change ${changeClass}`}>
                        {/* Icon size/color handled by CSS */}
                        <ChangeIcon className="kpi-card__change-icon" aria-hidden="true" />
                        <span className="sr-only">{isPositive ? 'Increased' : 'Decreased'} by</span>
                        {change}
                    </p>
                )}
            </div>
        </div>
    </div>
  );
};

export default KpiCard;